module.exports = __webpack_public_path__ + "static/img/小家电.70145ae8.png";